<template>
    <v-row class="ordinary--text">
        <v-col no-gutters>
            <v-row>
                <p class="ml-4 py-2 font-weight-black text-h5">
                    {{ $t('message.sharePackage') }}
                </p>
            </v-row>

            <v-col>
                <v-row justify="center">
                    <v-col cols="auto" sm="1" class="ml-sm-3 pr-0">
                        <v-icon large class="mt-3" color="grey lighten-1"
                            >mdi-account-circle-outline</v-icon
                        >
                    </v-col>

                    <v-col cols="auto" sm="6">
                        <p class="mt-2 mb-0">
                            {{ user.email }}
                        </p>
                        <p class="grey--text" inline>
                            {{ user.fullName }}
                        </p>
                    </v-col>
                    <v-col
                        class="d-flex flex-column align-items-center"
                        cols="12"
                        sm="auto"
                    >
                        <VueNumericInput
                            class="numeric-input-btn-style mx-auto"
                            v-model="numSharedCredits"
                            :min="0"
                            :max="maxNumSharedCredits"
                            align="center"
                        ></VueNumericInput>

                        <v-btn
                            @click="editPackageShare"
                            text
                            style="text-decoration: underline"
                            class="mt-2 tw-text-webAppFontColor mx-auto"
                            :disabled="editSharedPackageHook.isLoading.value"
                            :loading="editSharedPackageHook.isLoading.value"
                        >
                            {{
                                $t('message.shareCredits', {
                                    numCredits: numSharedCredits,
                                })
                            }}
                        </v-btn>
                    </v-col>
                </v-row>

                <v-divider class="tw-mt-1" />
            </v-col>

            <v-row class="tw-pt-5 tw-mt-8">
                <v-col cols="12" sm="4">
                    <p class="package-item-title tw-text-center">
                        {{ props.packageItem?.name }}
                    </p>
                </v-col>
                <v-col class="mt-sm-2 pt-0 pt-sm-3" cols="6" sm="4">
                    <v-row class="ml-md-4 ml-sm-2 ml-1">
                        <v-icon :color="webAppFontColor">
                            mdi-account-multiple-outline
                        </v-icon>
                        <p class="mt-4 mt-sm-3 ml-3">
                            {{
                                $t('message.peopleLeft', {
                                    numShareable:
                                        props.packageItem
                                            ?.originalNumPackageShareable,
                                    current:
                                        props.packageItem?.numPackageShareable,
                                })
                            }}
                        </p>
                    </v-row>
                </v-col>

                <v-divider vertical class="mt-0 mt-sm-1 mb-3 mb-sm-4" />

                <v-col class="mt-sm-2 pt-0 pt-sm-3" cols="6" sm="4">
                    <v-row class="ml-md-4 ml-sm-2 ml-1">
                        <v-icon :color="webAppFontColor">
                            mdi-bookmark-multiple
                        </v-icon>
                        <p class="mt-4 mt-sm-3 ml-2">
                            {{
                                $t('message.classesRemainingShort', {
                                    classesLeft: props.packageItem?.classesLeft,
                                    numberClasses:
                                        props.packageItem?.numberClasses,
                                })
                            }}
                        </p>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script setup lang="ts">
import { computed, ref, type Ref } from 'vue'
import { useEditSharedPackage } from './composable/useEditSharedPackage'
//@ts-expect-error no types
import VueNumericInput from 'vue-numeric-input'
import { useToast } from '@/components/base/toast/composable/useToast'
import { useI18n } from 'vue-i18n-composable'
import { useStudioStore } from '../bookclass/stores/studioStore'

const { t: $t } = useI18n()
const { showSuccessToast, showErrorToast } = useToast()
const emit = defineEmits<{
    (e: 'onSuccessEdit'): void
}>()
const props = defineProps({
    user: {
        type: Object,
        required: true,
    },
    packageItem: {
        type: Object,
        required: true,
    },
    sharedPackage: {
        type: Object,
        required: true,
    },
})

const numSharedCredits: Ref<number> = ref(props.sharedPackage.classesLeft)
const maxNumSharedCredits = computed(() => {
    if (props.sharedPackage) {
        return props.sharedPackage.classesLeft + props.packageItem.classesLeft
    }
    return 0
})
const editSharedPackageHook = useEditSharedPackage()

async function editPackageShare() {
    try {
        await editSharedPackageHook.editUserPackage({
            currentPackage: props.packageItem as any,
            creditShared: numSharedCredits.value,
            sharedPackage: props.sharedPackage as any,
        })
        showSuccessToast($t('message.successEditSharedPackage'))
        emit('onSuccessEdit')
    } catch (error: any) {
        showErrorToast(error.message)
    }
}

const studioStore = useStudioStore()
const webAppFontColor = computed(() => {
    return studioStore.studio.webAppFontColor || 'primary'
})
</script>

<style scoped>
.numeric-input-btn-style {
    background: white !important;
}
</style>
